import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Book Bank | Team Project(Hack36)',
        projectDesc: 'An Blockchain Platform for Researchers.A place where a researcher can mint their research paper and publish and also get funded onour platform.',
        tags: ['React', 'CSS', 'Material Ui','Redux','Polygon','NFT Storage','Meta-Mask','Portis','Javascript'],
        code: 'https://github.com/ProgrammingPirates/Binary_Fetch',
        demo: 'https://bookbankr.netlify.app',
        image: one
    },
    {
        id: 2,
        projectName: 'MNNIT Coding Platform',
        projectDesc: 'MNNIT Coding Platform is the perfect platform for you!.',
        tags: ['Javascript', 'Tailwind CSS','Html/Css','APIs','EJS'],
        code: 'https://github.com/ProgrammingPirates/Codekaro',
        demo: 'https://mnnitcoder.herokuapp.com/',
        image: two
    },
    {
        id: 3,
        projectName: 'Blockchain NFT Explorer',
        projectDesc: 'ERC721 NFT Collections directly from the blockchain.An alternative to OpenSea/Rarible.Browse big collections (9,999+ of items) on a single page.',
        tags: ['React17','Javascript','Redux','Chakra UI','IPFS','Polygon','Metamask','Cors Proxy','Dapp'],

        code: 'https://github.com/ProgrammingPirates/Blockchain-NFT-Explorer',
        demo: 'https://hacknitp2022.netlify.app/',
        image: three
    },
    {
        id: 4,
        projectName: 'Android Patient Tracker',
        projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
        tags: ['Flutter', 'Firebase'],
        code: '',
        demo: '',
        image: four
    },
    {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple E-commerce applica',
        image: five
    },
    {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'A Simple Uber Lite',
        image: six
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: '',
        demo: '',
        image: seven
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: '',
        demo: '',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
